import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'app-header-badge',
  templateUrl: './header-badge.component.html',
  styleUrl: './header-badge.component.scss'
})
export class HeaderBadgeComponent {
  @Input() text: string = '';
  @Input() isDisabled: boolean = false;
  @Input() customClass: string = '';

  @HostBinding('class') get hostClasses(): string {
    return this.customClass;
  }
}
